export default __webpack_public_path__ + "static/media/slide21.881e90ac.svg";